/**
 * @flow
 * @relayHash 18e9459d8888177c2af6d88b45fe6c82
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AppQueryRendererQueryResponse = {| |};
*/


/*
query AppQueryRendererQuery {
  ...SideBarRefetchContainer_data
  ...AudienceTableRefetchContainer_data
}

fragment SideBarRefetchContainer_data on Query {
  localeRegion_suggestions: stringSuggestion(field: "localeRegion", selector: "DEVICE", size: 100)
  sbDynamicSegment: dynamicSegment(segmentId: "") {
    segmentId
    name
    predicates {
      condition
      predicateList {
        __typename
        ... on AudiencePredicate {
          __typename
          ... on StringArrayPredicate {
            stringArrayValue
            stringArrayComparison
          }
          selector
          ... on StringPredicate {
            stringValue
            stringComparison
          }
          ... on VersionPredicate {
            versionValue
            versionComparison
          }
          attribute
          ... on BooleanPredicate {
            booleanValue
            booleanComparison
          }
          ... on NumberPredicate {
            numberValue
            numberComparison
          }
          ... on FloatPredicate {
            floatValue
            floatComparison
          }
          ... on GeofencePredicate {
            geofenceValue {
              latitude
              longitude
              radius
              name
            }
            geofenceComparison
          }
          ... on DatePredicate {
            dateValue {
              __typename
              ... on DatePredicateValue {
                start {
                  year
                  month
                  day
                }
              }
              ... on DurationPredicateValue {
                duration
              }
            }
            dateComparison
          }
        }
      }
    }
    id
  }
  segmentsContainer: dynamicSegment {
    ...SegmentsContainer_segments
    id
  }
  appBuild_suggestions: stringSuggestion(field: "appBuild", selector: "DEVICE", size: 100)
  appVersion_suggestions: stringSuggestion(field: "appVersion", selector: "DEVICE", size: 100)
  carrierName_suggestions: stringSuggestion(field: "carrierName", selector: "DEVICE", size: 100)
  deviceManufacturer_suggestions: stringSuggestion(field: "deviceManufacturer", selector: "DEVICE", size: 100)
  deviceModel_suggestions: stringSuggestion(field: "deviceModel", selector: "DEVICE", size: 100)
  localeLanguage_suggestions: stringSuggestion(field: "localeLanguage", selector: "DEVICE", size: 100)
  segmentSchema {
    deviceSchema {
      attribute
      __typename: type
      label
      selector
    }
    profileSchema {
      attribute
      __typename: type
      label
    }
  }
  location_address_country_suggestions: stringSuggestion(field: "location.address.country", selector: "DEVICE", size: 100)
  location_address_state_suggestions: stringSuggestion(field: "location.address.state", selector: "DEVICE", size: 100)
  location_address_city_suggestions: stringSuggestion(field: "location_city", selector: "DEVICE", size: 100)
  locationAuthorization_suggestions: stringSuggestion(field: "locationAuthorization", selector: "DEVICE", size: 100)
  notificationAuthorization_suggestions: stringSuggestion(field: "notificationAuthorization", selector: "DEVICE", size: 100)
  operatingSystemName_suggestions: stringSuggestion(field: "operatingSystemName", selector: "DEVICE", size: 100)
  sdkVersion_suggestions: stringSuggestion(field: "sdkVersion", selector: "DEVICE", size: 100)
  timeZone_suggestions: stringSuggestion(field: "timeZone", selector: "DEVICE", size: 100)
}

fragment AudienceTableRefetchContainer_data on Query {
  adgSegmentSchema: segmentSchema {
    deviceSchema {
      ... on SchemaAttribute {
        attribute
        __typename: type
        label
        selector
      }
    }
    profileSchema {
      ... on SchemaAttribute {
        attribute
        __typename: type
        label
      }
    }
  }
  adgSegmentsFromPredicates: segmentFromPredicates(predicates: "[]", pageNumber: 0, pageSize: 150, condition: "ANY") {
    segmentSize
    totalSize
    dataGridRows
  }
}

fragment SegmentsContainer_segments on DynamicSegment {
  name
  segmentId
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppQueryRendererQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "SideBarRefetchContainer_data",
        "args": null
      },
      {
        "kind": "FragmentSpread",
        "name": "AudienceTableRefetchContainer_data",
        "args": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AppQueryRendererQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "AppQueryRendererQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "SegmentSchema",
        "name": "segmentSchema",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "SchemaAttribute",
            "name": "deviceSchema",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "attribute",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": "__typename",
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "label",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "selector",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "SchemaAttribute",
            "name": "profileSchema",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "attribute",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": "__typename",
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "label",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": "location_address_country_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "location.address.country",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"location.address.country\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "LinkedField",
        "alias": "segmentsContainer",
        "args": null,
        "concreteType": "DynamicSegment",
        "name": "dynamicSegment",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "type": "DynamicSegment",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "segmentId",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": "appBuild_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "appBuild",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"appBuild\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "appVersion_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "appVersion",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"appVersion\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "carrierName_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "carrierName",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"carrierName\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "deviceManufacturer_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "deviceManufacturer",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"deviceManufacturer\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "deviceModel_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "deviceModel",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"deviceModel\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "localeLanguage_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "localeLanguage",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"localeLanguage\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "localeRegion_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "localeRegion",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"localeRegion\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "LinkedField",
        "alias": "sbDynamicSegment",
        "args": [
          {
            "kind": "Literal",
            "name": "segmentId",
            "value": "",
            "type": "ID"
          }
        ],
        "concreteType": "DynamicSegment",
        "name": "dynamicSegment",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "segmentId",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PredicateAggregate",
            "name": "predicates",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "condition",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": null,
                "name": "predicateList",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "GeofencePredicate",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "GeofenceValue",
                        "name": "geofenceValue",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "latitude",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "longitude",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "radius",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "geofenceComparison",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "attribute",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "DatePredicate",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "name": "dateValue",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "DurationPredicateValue",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "duration",
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "DatePredicateValue",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "DateValue",
                                "name": "start",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "year",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "month",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "day",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "dateComparison",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "StringArrayPredicate",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "stringArrayValue",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "stringArrayComparison",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "VersionPredicate",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "versionValue",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "versionComparison",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "FloatPredicate",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "floatValue",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "floatComparison",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "NumberPredicate",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "numberValue",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "numberComparison",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "BooleanPredicate",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "booleanValue",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "booleanComparison",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "StringPredicate",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "stringValue",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "stringComparison",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "selector",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "dynamicSegment{\"segmentId\":\"\"}"
      },
      {
        "kind": "ScalarField",
        "alias": "location_address_state_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "location.address.state",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"location.address.state\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "location_address_city_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "location_city",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"location_city\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "locationAuthorization_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "locationAuthorization",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"locationAuthorization\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "notificationAuthorization_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "notificationAuthorization",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"notificationAuthorization\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "operatingSystemName_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "operatingSystemName",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"operatingSystemName\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "sdkVersion_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "sdkVersion",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"sdkVersion\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "ScalarField",
        "alias": "timeZone_suggestions",
        "args": [
          {
            "kind": "Literal",
            "name": "field",
            "value": "timeZone",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "selector",
            "value": "DEVICE",
            "type": "String!"
          },
          {
            "kind": "Literal",
            "name": "size",
            "value": 100,
            "type": "Int!"
          }
        ],
        "name": "stringSuggestion",
        "storageKey": "stringSuggestion{\"field\":\"timeZone\",\"selector\":\"DEVICE\",\"size\":100}"
      },
      {
        "kind": "LinkedField",
        "alias": "adgSegmentSchema",
        "args": null,
        "concreteType": "SegmentSchema",
        "name": "segmentSchema",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "SchemaAttribute",
            "name": "deviceSchema",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "SchemaAttribute",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "attribute",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "__typename",
                    "args": null,
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "selector",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "SchemaAttribute",
            "name": "profileSchema",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "SchemaAttribute",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "attribute",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "__typename",
                    "args": null,
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "label",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": "adgSegmentsFromPredicates",
        "args": [
          {
            "kind": "Literal",
            "name": "condition",
            "value": "ANY",
            "type": "String"
          },
          {
            "kind": "Literal",
            "name": "pageNumber",
            "value": 0,
            "type": "Int"
          },
          {
            "kind": "Literal",
            "name": "pageSize",
            "value": 150,
            "type": "Int"
          },
          {
            "kind": "Literal",
            "name": "predicates",
            "value": "[]",
            "type": "String!"
          }
        ],
        "concreteType": "SegmentData",
        "name": "segmentFromPredicates",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "segmentSize",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalSize",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dataGridRows",
            "storageKey": null
          }
        ],
        "storageKey": "segmentFromPredicates{\"condition\":\"ANY\",\"pageNumber\":0,\"pageSize\":150,\"predicates\":\"[]\"}"
      }
    ]
  },
  "text": "query AppQueryRendererQuery {\n  ...SideBarRefetchContainer_data\n  ...AudienceTableRefetchContainer_data\n}\n\nfragment SideBarRefetchContainer_data on Query {\n  localeRegion_suggestions: stringSuggestion(field: \"localeRegion\", selector: \"DEVICE\", size: 100)\n  sbDynamicSegment: dynamicSegment(segmentId: \"\") {\n    segmentId\n    name\n    predicates {\n      condition\n      predicateList {\n        __typename\n        ... on AudiencePredicate {\n          __typename\n          ... on StringArrayPredicate {\n            stringArrayValue\n            stringArrayComparison\n          }\n          selector\n          ... on StringPredicate {\n            stringValue\n            stringComparison\n          }\n          ... on VersionPredicate {\n            versionValue\n            versionComparison\n          }\n          attribute\n          ... on BooleanPredicate {\n            booleanValue\n            booleanComparison\n          }\n          ... on NumberPredicate {\n            numberValue\n            numberComparison\n          }\n          ... on FloatPredicate {\n            floatValue\n            floatComparison\n          }\n          ... on GeofencePredicate {\n            geofenceValue {\n              latitude\n              longitude\n              radius\n              name\n            }\n            geofenceComparison\n          }\n          ... on DatePredicate {\n            dateValue {\n              __typename\n              ... on DatePredicateValue {\n                start {\n                  year\n                  month\n                  day\n                }\n              }\n              ... on DurationPredicateValue {\n                duration\n              }\n            }\n            dateComparison\n          }\n        }\n      }\n    }\n    id\n  }\n  segmentsContainer: dynamicSegment {\n    ...SegmentsContainer_segments\n    id\n  }\n  appBuild_suggestions: stringSuggestion(field: \"appBuild\", selector: \"DEVICE\", size: 100)\n  appVersion_suggestions: stringSuggestion(field: \"appVersion\", selector: \"DEVICE\", size: 100)\n  carrierName_suggestions: stringSuggestion(field: \"carrierName\", selector: \"DEVICE\", size: 100)\n  deviceManufacturer_suggestions: stringSuggestion(field: \"deviceManufacturer\", selector: \"DEVICE\", size: 100)\n  deviceModel_suggestions: stringSuggestion(field: \"deviceModel\", selector: \"DEVICE\", size: 100)\n  localeLanguage_suggestions: stringSuggestion(field: \"localeLanguage\", selector: \"DEVICE\", size: 100)\n  segmentSchema {\n    deviceSchema {\n      attribute\n      __typename: type\n      label\n      selector\n    }\n    profileSchema {\n      attribute\n      __typename: type\n      label\n    }\n  }\n  location_address_country_suggestions: stringSuggestion(field: \"location.address.country\", selector: \"DEVICE\", size: 100)\n  location_address_state_suggestions: stringSuggestion(field: \"location.address.state\", selector: \"DEVICE\", size: 100)\n  location_address_city_suggestions: stringSuggestion(field: \"location_city\", selector: \"DEVICE\", size: 100)\n  locationAuthorization_suggestions: stringSuggestion(field: \"locationAuthorization\", selector: \"DEVICE\", size: 100)\n  notificationAuthorization_suggestions: stringSuggestion(field: \"notificationAuthorization\", selector: \"DEVICE\", size: 100)\n  operatingSystemName_suggestions: stringSuggestion(field: \"operatingSystemName\", selector: \"DEVICE\", size: 100)\n  sdkVersion_suggestions: stringSuggestion(field: \"sdkVersion\", selector: \"DEVICE\", size: 100)\n  timeZone_suggestions: stringSuggestion(field: \"timeZone\", selector: \"DEVICE\", size: 100)\n}\n\nfragment AudienceTableRefetchContainer_data on Query {\n  adgSegmentSchema: segmentSchema {\n    deviceSchema {\n      ... on SchemaAttribute {\n        attribute\n        __typename: type\n        label\n        selector\n      }\n    }\n    profileSchema {\n      ... on SchemaAttribute {\n        attribute\n        __typename: type\n        label\n      }\n    }\n  }\n  adgSegmentsFromPredicates: segmentFromPredicates(predicates: \"[]\", pageNumber: 0, pageSize: 150, condition: \"ANY\") {\n    segmentSize\n    totalSize\n    dataGridRows\n  }\n}\n\nfragment SegmentsContainer_segments on DynamicSegment {\n  name\n  segmentId\n}\n"
};

module.exports = batch;
